import React from 'react'
import Worker from './edit'
import { Link, withRouter } from 'react-router-dom'
import ArticleForm from '../components/form/form.component'
import FormHelper from '../../../../utils/FormHelper'
import Dialog from '../../../../components/dialog/dialog.component'
import Loading from '../../../../components/loading/loading.component'
import UploadPdf from '../components/upload-pdf/upload-pdf.component'
import Pdf from '../components/pdf/pdf.component'
import './edit.styles.scss'

class EditArticle extends React.Component {

    constructor() {
        super()
        this.worker = Worker(this)
        this.state = this.worker.getDefaultState()
    }

    componentDidMount() {
        this.worker.loadJournals()
        this.worker.loadArticle()
    }

    onSubmit = (e) => {
        e.preventDefault()
        this.worker.isValid() && this.worker.updateArticle()
    }

    onCancel = () => this.props.history.push('/article/articles')

    render() {
        return (
            <div id="editArticle" className="edit-article">
                {(this.state.updating || this.state.loadingArticle) && <Dialog><Loading /></Dialog>}
                {this.state.showUploadPdf && (
                    <Dialog>
                        <UploadPdf
                            onPdfUploaded={this.worker.onPdfUploaded}
                            onCancel={() => this.worker.showUploadPdf(false)}
                        />
                    </Dialog>
                )}
                <div className="card">
                    <Link className="btn" to="/article/articles">Articles</Link>
                    <div className="header">
                        <h4>Edit Article</h4>
                    </div>
                    <div className={"flag " + this.state.flag.type}>
                        {this.state.flag.text}
                    </div>
                    <ArticleForm {...this.state} mode="edit" action="Save" onChange={FormHelper(this).onChange} onSubmit={this.onSubmit} onCancel={this.onCancel}/>
                    <div className="header">
                        <h4>PDF</h4>
                    </div>
                    {this.state.pdf ? <Pdf pdf={this.state.pdf} /> : <p>No PDF uploaded</p>}
                    <span className="btn" onClick={() => this.worker.showUploadPdf(true)}>Upload PDF</span>
                </div>
            </div>
        )
    }
}

export default withRouter(EditArticle)
